 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCVI from '@/components/OEBPS/cvi'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSC01 from '@/components/OEBPS/c01'
 import OEBPSC02 from '@/components/OEBPS/c02'
 import OEBPSC03 from '@/components/OEBPS/c03'
 import OEBPSC04 from '@/components/OEBPS/c04'
 import OEBPSC05 from '@/components/OEBPS/c05'
 import OEBPSC06 from '@/components/OEBPS/c06'
 import OEBPSC07 from '@/components/OEBPS/c07'
 import OEBPSC08 from '@/components/OEBPS/c08'
 import OEBPSC09 from '@/components/OEBPS/c09'
 import OEBPSC10 from '@/components/OEBPS/c10'
 import OEBPSC11 from '@/components/OEBPS/c11'
 import OEBPSC12 from '@/components/OEBPS/c12'
 import OEBPSC13 from '@/components/OEBPS/c13'
 import OEBPSC14 from '@/components/OEBPS/c14'
 import OEBPSC15 from '@/components/OEBPS/c15'
 import OEBPSC16 from '@/components/OEBPS/c16'
 import OEBPSC17 from '@/components/OEBPS/c17'
 import OEBPSC18 from '@/components/OEBPS/c18'
 import OEBPSC19 from '@/components/OEBPS/c19'
 import OEBPSC20 from '@/components/OEBPS/c20'
 import OEBPSC21 from '@/components/OEBPS/c21'
 import OEBPSC22 from '@/components/OEBPS/c22'
 import OEBPSC23 from '@/components/OEBPS/c23'
 import OEBPSCOP from '@/components/OEBPS/cop'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cvi",
 			"name" : "OEBPS/cvi",
 			"component" : OEBPSCVI
 		},
 		{
 			"path" : "/OEBPS/tp",
 			"name" : "OEBPS/tp",
 			"component" : OEBPSTP
 		},
 		{
 			"path" : "/OEBPS/ack",
 			"name" : "OEBPS/ack",
 			"component" : OEBPSACK
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/c01",
 			"name" : "OEBPS/c01",
 			"component" : OEBPSC01
 		},
 		{
 			"path" : "/OEBPS/c02",
 			"name" : "OEBPS/c02",
 			"component" : OEBPSC02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js